module.exports = __webpack_public_path__ + "img/Z86_13.a97fd056.jpg";